// src/app/shared/constants/audit-field-labels.ts

export const AUDIT_FIELD_LABELS: Record<string, Record<string, string>> = {

  DEVIS: {
    devisStatut:          'Statut',
    devisNumeroContrat:   'N° Contrat',
    devisNomContrat:      'Nom du contrat',
    devisPrixUoPropose:   'Prix UO proposé',
    devisDateDemarrageGo: 'Date démarrage GO',
    devisDuree:           'Durée',
    devisProvisionFrais:  'Provision frais',
    devisMontantTotal:    'Montant total',
    devisCommentaire:     'Commentaire',
    devisReference:       'Référence',
    devisMajore:          'Majoré',
    devisMotifRefus:      'Motif de refus',
    devisNumeroBdc:       'N° BDC',
    devisDateFinTravaux:  'Date fin travaux',
    devisBeneficiaire:    'Bénéficiaire',
    devisPrixUoGrille:    'Prix UO grille',
  },

  DEMAND: {
    state:                'Statut',
    reference:            'Référence',
    load:                 'Charge totale',
    cost:                 'Montant total',
    serviceType:          'Service',
    prestationType:       'Type de prestation',
    facturationMode:      'Mode de facturation',
    deliveryDate:         'Date de livraison',
    realizationDateTime:  'Date de réalisation',
    revisedDeliveryDate:  'Date livraison revue',
    jiraReference:        'Référence JIRA',
  },

  FEB: {
    febStatut:                          'Statut',
    febLabel:                           'Label',
    febDuree:                           'Durée',
    febNomenclature:                    'Nomenclature',
    febContexteObjectifProjet:          'Contexte / Objectif',
    febDescriptionBesoin:               'Description du besoin',
    febNbAnneesExperiences:             'Années d\'expérience',
    febCompetencesTechniques:           'Compétences techniques',
    febCompetencesFonctionnelles:       'Compétences fonctionnelles',
    febProvisionDeplacementAstreinte:   'Provision déplacement',
  }
};

export const AUDIT_EXCLUDED_FIELDS: string[] = [
  'updatedAt', 'createdAt',
  'devisUpdatedAt', 'devisCreatedAt',
  'febUpdatedAt', 'febCreatedAt'
];